/**
 * Submenú de **Inventario** (Gestión).
 *
 * Las tres pantallas del inventario se repiten el mismo acceso para poder saltar
 * entre el listado de stock y los dos históricos de movimientos sin volver al
 * menú lateral.
 */

import { ArrowDownToLine, ArrowUpFromLine, Boxes, type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

export type InventarioSeccion = 'listado' | 'entradas' | 'salidas';

interface Enlace {
  seccion: InventarioSeccion;
  to: string;
  label: string;
  icono: LucideIcon;
}

/** Orden del submenú (coincide con el catálogo de módulos). */
const ENLACES: readonly Enlace[] = [
  { seccion: 'listado', to: '/gestion/inventario', label: 'Listado', icono: Boxes },
  { seccion: 'entradas', to: '/gestion/inventario/entradas', label: 'Entradas', icono: ArrowDownToLine },
  { seccion: 'salidas', to: '/gestion/inventario/salidas', label: 'Salidas', icono: ArrowUpFromLine },
];

const BASE =
  'inline-flex shrink-0 items-center gap-2 rounded-control px-3 py-2 text-xs font-semibold transition-colors';
const INACTIVO = 'border border-ink-200 bg-white text-ink-700 hover:border-brand-300 hover:text-brand-700';
const ACTIVO = 'bg-ink-900 text-white';

interface InventarioNavProps {
  /** Sección actualmente visible; se resalta en la barra. */
  active: InventarioSeccion;
  className?: string;
}

export function InventarioNav({ active, className }: InventarioNavProps) {
  return (
    <nav className={cn('flex items-center gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:pb-0', className)} aria-label="Secciones del inventario">
      {ENLACES.map((enlace) => (
        <Link
          key={enlace.seccion}
          to={enlace.to}
          aria-current={enlace.seccion === active ? 'page' : undefined}
          className={cn(BASE, enlace.seccion === active ? ACTIVO : INACTIVO)}
        >
          <enlace.icono className="size-3.5" aria-hidden="true" />
          {enlace.label}
        </Link>
      ))}
    </nav>
  );
}
